import { AbstractControl, ValidatorFn } from "@angular/forms";

export function autoSaveNotReadyValidator(autoSaveReady: boolean): ValidatorFn {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    if (control.value && !autoSaveReady) {
      return { 'autoSaveNotReady': true };
    }
    return null;
  };
}



// WEBPACK FOOTER //
// ./src/app/common/validators/autoSaveNotReadyValidator.ts